import { ReactNode, RefObject } from 'react'
import { ScrollView, StyleProp, ViewStyle } from 'react-native'
import { IconName } from '@components/base'
import { ThemeColor } from '@src/style/theme'

export enum NoraHomeWalkthroughTargetId {
  AskNoraInput = 'askNoraInput',
  Settings = 'settings',
  QuickPromptsHeader = 'quickPromptsHeader',
  ConversationsHeader = 'conversationsHeader',
}

export enum NoraHomeWalkthroughStepId {
  Introduction = 'introduction',
  AskNora = 'askNora',
  QuickPrompts = 'quickPrompts',
  Settings = 'settings',
  Conversations = 'conversations',
  Capabilities = 'capabilities',
}

type BaseStep = {
  id: NoraHomeWalkthroughStepId
  title: string
  body: string
  icon: IconName
  iconBackgroundColor: ThemeColor
  iconColor: ThemeColor
}

export enum NoraHomeWalkthroughPresentation {
  Anchored = 'anchored',
  Standalone = 'standalone',
}

export type AnchoredStep = BaseStep & {
  presentation: NoraHomeWalkthroughPresentation.Anchored
  targetId: NoraHomeWalkthroughTargetId
}

export type StandaloneStep = BaseStep & {
  presentation: NoraHomeWalkthroughPresentation.Standalone
  showSkip?: boolean
  actions?: string[]
}

export type NoraHomeWalkthroughStep = AnchoredStep | StandaloneStep

export type NoraHomeWalkthroughLayout = {
  isCompact: boolean
  standalonePadding: number
  pageControlBottom: number
  cardMaxWidth: number
  cardPadding: number
  cardTopPadding: number
  cardGap: number
  cardIconSize: number
  iconSize: number
  bodyLineHeight: number
  actionChipHeight: number
  actionStackGap: number
}

export interface NoraHomeWalkthroughProviderProps {
  children: ReactNode
  onClose: () => void
  onComplete: () => void
}

export interface NoraHomeWalkthroughTargetProps {
  targetId: NoraHomeWalkthroughTargetId
  accessibilityLabel: string
  children: ReactNode
  style?: StyleProp<ViewStyle>
}

export interface NoraHomeWalkthroughProps {
  scrollViewRef?: RefObject<ScrollView | null>
}
